import { useFormikContext } from "formik";
import BsForm from "react-bootstrap/Form";
import { SealRegistrationFormData } from "../SealRegistrationContext";

export const ConferenceInterestSection = () => {
  const { values, setFieldValue } = useFormikContext<SealRegistrationFormData>();

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">
        Optional: Consider joining the Old Vine Conference
      </h2>
      <p className="form-fields-sub-text" style={{ marginBottom: "18px" }}>
        Demonstrate your commitment to the protection and nurture of old vine
        heritage. Conference membership gives organizations access to a growing,
        diverse, and highly engaged global community of media, trade, and
        consumers.
      </p>

      <BsForm.Check
        className="checkbox-label-text"
        checked={values.conferenceInterest}
        onChange={() =>
          setFieldValue("conferenceInterest", !values.conferenceInterest)
        }
        label="I am interested in learning more about Old Vine Conference membership. Please contact me."
      />
    </div>
  );
};
